import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_item_to_item_addon_link_RowClass } from '../../../dbschema';

export class ItemToItemAddOnLinkContainerModel extends BaseContainerModel {

  bl_fi_item_to_item_addon_link: bl_fi_item_to_item_addon_link_RowClass = new bl_fi_item_to_item_addon_link_RowClass();
}
